// src/pages/projects/EditProjectPage.jsx

import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Loader2 } from 'lucide-react';
import ProjectForm from '@/components/projects/ProjectForm';
import { projectsAPI } from '@/services/projects';
import { useNotifications } from '@/contexts/NotificationContext';

const EditProjectPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addNotification } = useNotifications();

  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        setLoading(true);
        const response = await projectsAPI.details(id);

        if (response.success) {
          // ✅ تحويل البيانات من snake_case إلى camelCase
          const apiData = response.data;

          const formattedData = {
  id: apiData.id,
  projectName: apiData.project_name || '',
  companyName: apiData.company_name || '',
  companyAddress: apiData.company_address || '',
  contactEmail: apiData.contact_email || '',
  contactPhone: apiData.contact_phone || '',
  projectLocation: apiData.project_location || '',
  workType: apiData.work_type || '',
  receivedBy: apiData.received_by || '',
  description: apiData.description || '',
  status: apiData.status || 'New Inquiry',
  projectStatus: apiData.project_status || 'Pending',
  
  // ✅ Parse attachments (General Documents)
  attachments: Array.isArray(apiData.attachments) 
    ? apiData.attachments 
    : (typeof apiData.attachments === 'string' 
        ? JSON.parse(apiData.attachments || '[]') 
        : []),
  
  // ✅ Parse email_attachments (Email Correspondence)
  emailAttachments: Array.isArray(apiData.email_attachments)
    ? apiData.email_attachments
    : (typeof apiData.email_attachments === 'string'
        ? JSON.parse(apiData.email_attachments || '[]')
        : []),
  
  checklist: Array.isArray(apiData.checklist)
    ? apiData.checklist
    : (typeof apiData.checklist === 'string'
        ? JSON.parse(apiData.checklist || '[]')
        : [])
};


          console.log('✅ Formatted data for edit:', formattedData);
          setProject(formattedData);
        } else {
          addNotification('Error', 'Project not found', 'error');
          navigate('/projects');
        }
      } catch (error) {
        console.error('Failed to load project:', error);
        addNotification('Error', 'Failed to load project', 'error');
        navigate('/projects');
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [id, navigate, addNotification]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="w-8 h-8 animate-spin text-safety-orange" />
      </div>
    );
  }

  if (!project) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Edit Project - {project.projectName}</title>
      </Helmet>

      <div className="container mx-auto px-4 py-8 max-w-7xl">
        <div className="mb-6">
          <Button
            variant="ghost"
            onClick={() => navigate('/projects')}
            className="mb-4 gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Projects
          </Button>
          <h1 className="text-3xl font-bold text-navy-steal">Edit Project</h1>
          <p className="text-slate-600 mt-1">
            Update project details below
          </p>
        </div>

        <ProjectForm initialData={project} isEdit={true} />
      </div>
    </>
  );
};

export default EditProjectPage;